import React from "react";
import { Link } from "react-router-dom";
import styles from "./notFound.module.css";
import {
  CONTACT_EMAIL,
  CONTACT_MOBILE,
  CONTACT_MOBILE_LABEL,
  CONTACT_US_URL,
} from "../../utility/contactInfo";

const TIPS = [
  {
    icon: "fa-solid fa-link",
    title: "Check your link",
    text: "Make sure you opened the complete link shared by the hotel.",
  },
  {
    icon: "fa-solid fa-hotel",
    title: "Contact the hotel",
    text: "Ask the hotel to share their latest booking link with you.",
  },
];

// shown on /hotel/:id when the id has no hotel (error = false) or when the
// hotel details could not be loaded at all (error = true, offers a retry)
function HotelNotFound({ hotelId, error = false, onRetry }) {
  return (
    <div className={styles.notFoundPage}>
      <main className={styles.notFoundMain}>
        <div className={`${styles.notFoundCard} ${styles.hotelNotFoundCard}`}>
          <span
            className={`${styles.notFoundIcon} ${
              error ? styles.notFoundIconError : styles.notFoundIconWarn
            }`}
            aria-hidden="true"
          >
            <i
              className={
                error
                  ? "fa-solid fa-wifi"
                  : "fa-solid fa-building-circle-xmark"
              }
            ></i>
          </span>
          <p className={styles.notFoundCode}>
            {error ? "Connection problem" : "Invalid booking link"}
          </p>
          <h1 className={styles.notFoundTitle}>
            {error ? "We couldn't load this hotel" : "Hotel not found"}
          </h1>
          <p className={styles.notFoundText}>
            {error
              ? "Something went wrong while loading the hotel details. Please check your internet connection and try again."
              : "We couldn't find a hotel for this link. The link may be incorrect, or the hotel's booking page may no longer be active."}
          </p>

          {hotelId && (
            <p className={styles.hotelIdChip}>
              <i className="fa-solid fa-hashtag" aria-hidden="true"></i>
              <span>Hotel ID</span>
              <code title={hotelId}>{hotelId}</code>
            </p>
          )}

          <div className={styles.notFoundActions}>
            {error ? (
              <button
                type="button"
                className={styles.notFoundPrimary}
                onClick={onRetry}
              >
                <i className="fa-solid fa-rotate-right" aria-hidden="true"></i>
                Try again
              </button>
            ) : (
              <Link to="/" className={styles.notFoundPrimary}>
                <i className="fa-solid fa-house" aria-hidden="true"></i>
                Go to home
              </Link>
            )}
            <a href={CONTACT_US_URL} className={styles.notFoundSecondary}>
              <i className="fa-solid fa-headset" aria-hidden="true"></i>
              Contact Us
            </a>
          </div>

          {!error && (
            <ul className={styles.tipList}>
              {TIPS.map((tip) => (
                <li key={tip.title}>
                  <span className={styles.tipIcon} aria-hidden="true">
                    <i className={tip.icon}></i>
                  </span>
                  <div>
                    <p className={styles.tipTitle}>{tip.title}</p>
                    <p className={styles.tipText}>{tip.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          )}

          <div className={styles.helpBox}>
            <p className={styles.helpTitle}>Still need help?</p>
            <div className={styles.helpLinks}>
              <a href={`tel:${CONTACT_MOBILE}`}>
                <i className="fa-solid fa-phone" aria-hidden="true"></i>
                {CONTACT_MOBILE_LABEL}
              </a>
              <a href={`mailto:${CONTACT_EMAIL}`}>
                <i className="fa-regular fa-envelope" aria-hidden="true"></i>
                {CONTACT_EMAIL}
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default HotelNotFound;
